import styled, {css} from "styled-components";

interface GameSearchDefaultBoxProps {
    open: boolean;
}

export const GameSearchDefaultBox = styled.div<GameSearchDefaultBoxProps>`
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        ${({open}) => open && css`
            flex: 1;
        `}
    }
    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
        position: relative;
        display: flex;
    }
`;
